import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FtextField } from "../../../components/common/FtextField";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
  ModalFooter,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/common/Loader";
import { updateIspOwnerSupporterNumber } from "../../../features/apiCalls";

const SupportNumberEdit = ({ supportId, editShow, setEditShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // netFee support data
  const ispOwnerSupportNumbers = useSelector(
    (state) => state.netFeeSupport?.ispOwnerSupport,
  );

  //get isp owner id
  const ispOwner = useSelector(
    (state) => state.persistedReducer.auth?.ispOwnerId,
  );

  //Loading state
  const [isLoading, setIsLoading] = useState(false);

  // single support number find
  const singleSupport = ispOwnerSupportNumbers.find(
    (val) => val.id === supportId,
  );

  // supports validation
  const customerValidator = Yup.object({
    name: Yup.string().min(3).required(t("writeSupportName")),
    mobile: Yup.string().required(t("writeMobileNumber")),
    start: Yup.date().required(t("selectStartTime")),
    end: Yup.date().required(t("selectEndTime")),
  });

  // modal close handler
  const handleClose = () => setEditShow(false);

  // support update submit handler
  const supportNumbersUpdateHandler = (formValues) => {
    const sendingData = {
      ...formValues,
      ispOwner: ispOwner,
    };

    updateIspOwnerSupporterNumber(
      dispatch,
      sendingData,
      ispOwner,
      supportId,
      setIsLoading,
      setEditShow,
    );
  };

  return (
    <Modal
      show={editShow}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader closeButton>
        <ModalTitle>{t("createCustomersSupporter")}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            name: singleSupport?.name,
            mobile: singleSupport?.mobile,
            start: new Date(singleSupport?.start),
            end: new Date(singleSupport?.end),
          }}
          validationSchema={customerValidator}
          onSubmit={(values) => {
            supportNumbersUpdateHandler(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form id="support">
              <div className="displayGrid">
                <FtextField
                  type="text"
                  label={t("name")}
                  name="name"
                  validation={"true"}
                />

                <FtextField
                  type="text"
                  label={t("mobile")}
                  name="mobile"
                  validation={"true"}
                />

                <FtextField
                  {...{
                    name: "start",
                    type: "date",
                    id: "start",
                    validation: true,
                    label: t("selectStartTime"),
                    placeholderText: "HH:mm A",
                    component: "DatePicker",
                    dateFormat: "hh:mm a",
                    timeIntervals: 1,
                    showTimeSelect: true,
                    showTimeSelectOnly: true,
                  }}
                />

                <FtextField
                  {...{
                    name: "end",
                    type: "date",
                    id: "end",
                    validation: true,
                    label: t("selectEndTime"),
                    placeholderText: "HH:mm A",
                    component: "DatePicker",
                    dateFormat: "hh:mm a",
                    timeIntervals: 1,
                    showTimeSelect: true,
                    showTimeSelectOnly: true,
                  }}
                />
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={isLoading}
          type="submit"
          className="btn btn-success"
          form="support"
        >
          {isLoading ? <Loader /> : "submit"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SupportNumberEdit;
